import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6b3b8e62&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=6b3b8e62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3b8e62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b3b8e62')) {
      api.createRecord('6b3b8e62', component.options)
    } else {
      api.reload('6b3b8e62', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6b3b8e62&scoped=true&", function () {
      api.rerender('6b3b8e62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/publicizeMaterialManagement/reviewInfo/index.vue"
export default component.exports